"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _QTH7UFAPcjs = require('../__chunks/QTH7UFAP.cjs');
require('../__chunks/XUEEOXY3.cjs');
require('../__chunks/MKJKL65R.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');



exports.HovercardDescription = _QTH7UFAPcjs.HovercardDescription; exports.useHovercardDescription = _QTH7UFAPcjs.useHovercardDescription;
